<template>
  <main id="output">
      <Menu @screenshot="snapScreenshot" />
      <section class="groups" ref="groups">
        <Group v-for="group of groups" :key="group.id" :group="group" />
      </section>
  </main>
</template>

<script>

import Menu from '@/components/Menu';
import Group from '@/components/Group';
import html2canvas from 'html2canvas';

export default {
    name: 'Output',
    components: {
      Menu,
      Group
    },
    methods: {
      async snapScreenshot(){      
        const canvas = await html2canvas(this.$refs.groups, { backgroundColor: null, scale: 1.5 });
        let link = document.createElement('a');
        link.download = `screenshot-groupie-${Date.now()}.png`;
        link.href = canvas.toDataURL("image/png");
        link.click();
      }
    },
    computed: {
      groups(){
        return this.$store.state.generatedGroups;
      }
    },
    beforeMount(){
      this.$store.commit('configMenuUI', { 
        close: false, 
        back: true,
        navicon: false,
        crossGroups: true,
        remix: true,
        screenshot: true,
        share: true  
        })
    }
}
</script>

<style lang="scss">
@import './../scss/variables';

#output {
    background: $groupieGradient;
    @include center;
    flex-direction: column;
    padding: 1rem;

    > .groups {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 1rem;
      padding: 1rem;
      max-width: 800px;
      width: 100%;

      @media (max-width: 640px ){
        grid-template-columns: repeat(2, 1fr);
      }

      @media (max-width: 480px ){
        grid-template-columns: repeat(1, 1fr);
      }

    }

}
</style>